<template>
  <div :class="{ desktop: isDesktop }" class="full-width">
    <el-switch
      v-if="withSpecific"
      v-model="anyVersion"
      active-text="Any version"
      inactive-text="Specific versions"
    />
    <div class="mt-1">
      <el-select
        v-if="anyVersion || !withSpecific"
        v-model="value.browsers"
        multiple
        placeholder="All"
        @update:modelValue="commonUpdated"
      >
        <el-option
          v-for="item in browserOptions"
          :key="item.key"
          :label="item.label"
          :value="item.key"
        />
      </el-select>
      <div v-else>
        <SpecificBrowsersSelector
          v-if="withSpecific"
          v-model="value.specific"
          @update:modelValue="specificUpdated"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'
import {
  Browser,
  BrowserLabel,
  BrowserLabels,
  SpecificVersion
} from '@/api/types'
import SpecificBrowsersSelector from './SpecificBrowsersSelector.vue'
import useResize from '@/hooks/useResize'

type BrowserEntry = {
  key: Browser
  label: string
  disabled: boolean
}

export default defineComponent({
  name: 'BrowsersSelector',
  components: {
    SpecificBrowsersSelector
  },
  props: {
    modelValue: {
      type: Object,
      required: true
    },
    withSpecific: {
      type: Boolean,
      default: true
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)
    const initialAny = props.modelValue.specific
      ? props.modelValue.specific.length === 0
      : false
    const anyVersion = ref(initialAny)

    const browserOptions = BrowserLabels.map<BrowserEntry>(
      (browserLabel: BrowserLabel) => {
        return {
          key: browserLabel.type_id,
          label: browserLabel.label,
          disabled: false
        }
      }
    )

    watch(anyVersion, (value, _oldValue) => {
      if (value === true) {
        context.emit('update:modelValue', {
          browsers: props.modelValue.browsers,
          specific: []
        })
      }
    })

    watch(
      (_: any) => props.modelValue,
      (val: any) => {
        value.value = val
      }
    )

    function commonUpdated(newValue: Array<Browser>) {
      context.emit('update:modelValue', {
        browsers: newValue,
        specific: props.modelValue.specific
      })
    }

    function specificUpdated(newValue: Array<SpecificVersion<Browser>>) {
      context.emit('update:modelValue', {
        browsers: props.modelValue.browsers,
        specific: newValue
      })
    }

    const { isDesktop } = useResize()

    return {
      anyVersion,
      value,
      commonUpdated,
      specificUpdated,
      browserOptions,
      isDesktop
    }
  }
})
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;
}
</style>
